import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import AdminNavigation from '../Inc/AdminNavigation';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import './editalumni.css';
import { Input, Modal, Button, Upload, Tabs, message, Spin, Row, Col, Dropdown, Icon, Menu, Collapse, Form, Select, Radio, DatePicker, Checkbox } from 'antd';
import moment from 'moment';
import AlumniProfile from './alumniProfile'
import AlumniContact from './alumniContact'
import AlumniAddress from './alumniAddress'
import Skeleton from 'react-loading-skeleton';
import Summary from './Summary';
import Financial from './Financial';
import Memberships from './Memberships';
import RecordManagement from './RecordManagement';
import { history } from '../../container/History';
import alumniContact from './alumniContact';
import AlumniPrivacyOptions from '../Inc/AlumniPrivacyOptions';
import HobbiesAndBusinessComponent from '../Inc/HobbiesAndBusiness';


const TabPane = Tabs.TabPane;
const FormItem = Form.Item;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;


const formItemLayout = { wrapperCol: { span: 14, offset: 0 } }

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const isJPG = file.type === 'image/jpeg';
  if (!isJPG) {
    message.error('You can only upload JPG file!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }
  return isJPG && isLt2M;
}


class EditAlumni extends Component {

  constructor(props) {
    super(props)
    this.state = {
      ...props,
      personGUID: '',
      loading: false,
      returnto: 'list-and-search',
      prevPath: undefined
    }
  }

  // state = {
  //   loading: false,
  //   returnto: 'list-and-search'
  // };

  handleChange = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => this.setState({
        imageUrl,
        loading: false,
      }));
    }
  }

  componentDidMount = () => {
    const { match, PersonGuid, isspecialist, actions } = this.props;
    const { personGuid: routePersonGUID, returnto } = match.params || {};
    const prevPath = localStorage.getItem("prevPath");
  
    let personGUID = PersonGuid || routePersonGUID || this.state.personGUID;
  
    const newState = {};
  
    if (prevPath) {
      newState.prevPath = prevPath;
    }
  
    if (this.state.personGUID === '' && personGUID) {
      newState.personGUID = personGUID;
    }
  
    if (returnto) {
      newState.returnto = returnto;
    }
  
    if (Object.keys(newState).length > 0) {
      this.setState(newState);
    }
  
    if (personGUID) {
      actions.getAlumniEagleInfo(personGUID);
      actions.getAlumniInfo(personGUID, isspecialist ? "" : "admin");
      actions.getNESARegistrations(personGUID);
      actions.getSAFRegistrations(personGUID);
    }
  }  

  name = () => {
    if (!this.props.profileinfo) {
      return <Skeleton width={300} />
    }   
    else{
      const { profile } = this.props.profileinfo || {};
      const { firstName, middleName, lastName, nameSuffix, fullName } = profile || {};

      const formattedName =  `${firstName} ${middleName} ${lastName} ${nameSuffix ? nameSuffix : ''}`;
      return formattedName;
    }
      
  }
  checkIsDeceased = () => {
    if (!this.props.profileinfo) {
      return <Skeleton width={100} />
    }   
    else{
      const { profile } = this.props.profileinfo || {};
      const { isDeceased } = profile || this.props.profileinfo;

      return isDeceased ? "- Deceased" : '';
    }
      
  }

  summary = () => {
    if (!this.props.profileinfo)
      return <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Profile Summary..." />
    else
      return <Summary />
  }
  handelChangeBackToSearch = (data) => {
    this.props.removeEditAlumni(data)
  }
  renderProfileImg = () => {
    if (!this.props.profileinfo || this.props.pic_updating) {
      return <Spin indicator={LoadingIcon} className='flex-center' />
    }
    else {
      let profile = this.props.profileinfo
      let imgurl = profile && profile.profile &&  profile.profile.pictureUrl ? profile.profile.pictureUrl : profile && profile.pictureUrl ? profile.pictureUrl : '';
      if (imgurl == "" || imgurl == null) imgurl = "../../profileimage.png"
      return <img src={imgurl} className='' />
    }
  }
  renderWebContacts = () => {
    if (this.props.profileinfo) {
      let profile = this.props.profileinfo
      let webcontacts = profile.webContacts
      if (webcontacts.length != 0) {
        return webcontacts.map((k, index) => {
          if (k.typeId == "14") {
            return <a href={"https://" + k.type + ".com/" + k.address} target="_blank"><svg className="margin-right-10 fa-2x white pointer x-icon" width="1em" height="1em" viewBox="0 0 1200 1227" fill="currentColor" aria-hidden="true"><path d="M714.163 519.284L1160.89 0H1055.36L667.137 451.887L357.328 0H0L468.492 682.21L0 1226.37H105.527L515.256 750.965L841.672 1226.37H1199L714.137 519.284H714.163Z" /></svg></a>
          }
          if (k.typeId == "15") {
            return <a href={"https://" + k.type + ".com/" + k.address} target="_blank"><i className="fa fa-facebook-square margin-right-10 fa-2x white pointer" aria-hidden="true"></i></a>
          }
          if (k.typeId == "17") {
            return <a href={"https://" + k.type + ".com/in/" + k.address} target="_blank"><i className="fa fa-linkedin-square margin-right-10 fa-2x white pointer" aria-hidden="true"></i></a>
          }
          if (k.typeId == "19") {
            return <a href={"https://" + k.type + ".com/" + k.address} target="_blank"><i className="fa fa-instagram margin-right-10 fa-2x white pointer" aria-hidden="true"></i></a>
          }
        })
      }
    }
  }

  rendereagleflag = () => {
    if (this.props.eagleinfo) {
      if (Object.keys(this.props.eagleinfo).length != 0) {
        if (this.props.eagleinfo.eagleBoardReviewDate != "") {
          return <img  className="eagle-logo eagle-logo-img" src='../../eagle-scout.png' />
        }
      }
    }
  }

  render() {

    return (
      <div>
        {!this.props.PersonGuid && <LayoutHeader />}
        {!this.props.PersonGuid && <AdminNavigation />}

        <div className='edit-alumni'>
          <Row type="flex" justify="center">
            <Col xs={24} sm={24} md={24} lg={20} xl={20}>
              <Row>
                <Col span={24}>
                  <div className='container' >
                    <div className='alumni-content'>
                      <div className='alumni-bg-banner'>
                        <Row type="flex" justify="space-between">
                          {this.props.location.pathname.includes() == "/list-and-search" ? <span className='text pointer' onClick={() => history.push(`/${this.props.location.pathname}`)}><i className="fa fa-lg fa-long-arrow-left margin-right-5"></i> Back to Search Results</span> 
                          :
                          this.props.PersonGuid ? <span className='text pointer' onClick={() => {this.handelChangeBackToSearch("false")}}><i className="fa fa-lg fa-long-arrow-left margin-right-5"></i> Back to Search Results</span>
                            : <span className='text pointer' onClick={() => history.push('/' + this.state.returnto)}><i className="fa fa-lg fa-long-arrow-left margin-right-5"></i> Back to Search Results</span>}
                
                          <div>
                            {this.renderWebContacts()}
                          </div>
                        </Row>
                        <Row type="flex" justify="center">
                          <div>
                            <span className='alumni-name' style={{ display: 'inline' }}>{this.name()}</span>
                            <span className='breadcrums'>{this.checkIsDeceased()}</span>
                          </div>
                        </Row>
                        <div align="left">
                          {this.rendereagleflag()}
                        </div>
                      </div>
                      <Row type="flex" justify="center">
                        <div className='profile-img flex-center'>
                          {this.renderProfileImg()}
                        </div>
                      </Row>
                      <div className='' style={{ backgroundColor: '#f2f2f2' }}>
                        <Row type="flex" justify="space-around" align="bottom">
                          <Tabs style={{ width: '100%' }} defaultActiveKey="1">
                            <TabPane tab="Summary" key="1">
                              {/* {this.summary()} */}
                              <AlumniProfile />
                              {
                                this.state.personGUID && <div style={{    background: '#ffffff', borderRadius: '16px', boxShadow: '#00000012', marginBottom: '24px', border: '0px', overflow: 'hidden'}}>
                                  <div className='my-profile alumni-ui'>
                                    <AlumniPrivacyOptions personGUID={this.state.personGUID} viewableOnly={true} />
                                  </div>
                                </div>
                              }
                              <AlumniContact />
                              <AlumniAddress />
                              <HobbiesAndBusinessComponent personGUID={this.state.personGUID} eagleInfo={this.props.eagleinfo} />
                            </TabPane>
                            {/* <TabPane tab="Profile" key="2"><AlumniProfile /></TabPane>
                            <TabPane tab="Financial" key="3"><Financial /></TabPane> */}
                            <TabPane tab="Memberships" key="4"><Memberships personGUID={this.state.personGUID} /></TabPane>
                            {/* <TabPane tab="Record Management" key="7"><RecordManagement /></TabPane> */}
                          </Tabs>
                        </Row>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

      </div>
    );
  }

}



function mapStateToProps(state) {
  return {
    profileinfo: state.alumniinforeducer.profileinfo,
    eagleinfo: state.alumnieagleinforeducer.eagleinfo,
    isspecialist: state.isadminreducer.isspecialist,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(EditAlumni);


// WEBPACK FOOTER //
// ./src/components/MaintainAlumni/index.js